import Form from "./form";

export default function New() {
  return <Form />;
}
